/*@ngInject*/
const TextInputController = function ($scope, $controller, formViewerConstant, formComponentUtil, formMediator, xmlUtil) {

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}));

    this.$onInit = function () {
        this.onInit();

        let fieldTemplate = this.fieldStructure.uiField.fieldTemplate,
            validatorProperty;

        this.isCurrency = fieldTemplate.validator === 'currency';
        this.isPercentage = fieldTemplate.validator === 'percent';
        this.isNumber = fieldTemplate.validator === 'number';
        this.isNumberWithCommas = fieldTemplate.validator === 'number with commas';
        this.isNumberRange = fieldTemplate.validator === 'number range';
        this.isDate = fieldTemplate.validator === 'date';

        if (_.isNil(fieldTemplate.validatorProperty) && (this.isCurrency)) {
            this.isDisplayDollar = true;
        }

        if (fieldTemplate.validatorProperty) {
            validatorProperty = xmlUtil.parseString(fieldTemplate.validatorProperty);

            if (this.isCurrency) {
                const displayDollarSymbol = validatorProperty.displayDollarSymbol;
                this.isDisplayDollar = _.isUndefined(displayDollarSymbol) ? true : displayDollarSymbol;
                this.currencyRounding = validatorProperty.currencyRounding;
            }
            if (this.isPercentage || this.isNumber || this.isNumberWithCommas || this.isNumberRange) {
                this.numberDomain = validatorProperty.numberDomain;
            }
            if (this.isPercentage) {
                this.percentageAddPercent = validatorProperty.addPercent;
            }
        }

        this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
    };

    this.$onChanges = function () {
        this.onChanges();
    };

    this.handleChange = function () {
        this.fieldStructure.hasLocalChanges = true;
    };

    this.handleBlur = function () {
        let dateValue;
        if (this.fieldStructure.hasLocalChanges) {
            if (this.fieldStructure.rowRepeaterId) {
                this.fieldStructure.dynamicProperties.isValid = true;
            }

            if (this.isDate) {
                dateValue = formComponentUtil.dateFromInput(this.fieldStructure.fieldModel.value, false);
                this.fieldStructure.fieldModel.value = formComponentUtil.formatDateForServer(dateValue, false);
            }else if (this.isCurrency) {
                this.fieldStructure.fieldModel.value = formComponentUtil.roundCurrencyForServer(this.fieldStructure.fieldModel.value, this.currencyRounding);
            }

            formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
        }
    };

    this.getMaxChar = function (options) {
        let optionsObject = xmlUtil.parseString(options);
        return parseInt(optionsObject.maxChars) > 0 ? optionsObject.maxChars : null;
    };
};

angular.module('umFormViewer')
    .controller('textInputController', TextInputController);
